package com.ijoin.data.model

import kotlinx.serialization.Serializable

@Serializable
data class FeedItem(
    val id: String,
    val userId: String? = null,
    val event: Event,
    val type: FeedItemType,
    val score: Double? = null,
    val reason: String? = null,
    val createdAt: String? = null
)

@Serializable
enum class FeedItemType {
    RECOMMENDED,
    TRENDING,
    NEARBY,
    FOLLOWING,
    INTEREST_BASED,
    FRIEND_ACTIVITY
}
